import { Injectable } from '@angular/core';
import { Http} from '@angular/http';
import { environment } from '../../../../../environments/environment';
import 'rxjs/add/operator/toPromise';
import {StorageUtils} from '../../../utils';
import * as _ from 'lodash';

@Injectable()
export class ScheduleServices {
    private apiUrl = `${environment.apiUrl}/api/v1`;
    private companyId = global['loginUser'].curCmpnId;

    constructor(private http: Http) {
        this.companyId = global['loginUser'].curCmpnId;
    };

    public getMappInfo() {
        return 'sdfsdfsasadfdsdf';
    }
    /**
     * schedule
     * schedule list 조회
     * Method : Get
     * API No : 16.1
     * url : /api/v1/{cmpnNo}/schedule
     * **/
    getScheduleList(queryString?: any) {
        const queryParam = (queryString === undefined ? '' : queryString);
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/schedule${queryParam}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * schedule
     * schedule list 조회 (에스컬레이션용)
     * Method : Get
     * API No : 16.2
     * url : /api/v1/{cmpnNo}/schedule/list
     * **/
    getEscalScheduleList() {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/schedule/list`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * schedule
     * schedule Override 등록
     * Method : Post
     * API No : 16.3
     * url : /api/v1/{cmpnNo}/schedule/override/{schdLayerNo}
     * **/
    postScheduleOverride(schdLayerNo: any, postData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/schedule/override/${schdLayerNo}`;
        return this.http
            .post(url, JSON.stringify(postData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * schedule
     * schedule 등록
     * Method : Post
     * API No : 16.4
     * url : /api/v1/{cmpnNo}/schedule
     * **/
    postSchedule(postData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/schedule`;
        return this.http
            .post(url, JSON.stringify(postData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * schedule
     * schedule detail 조회
     * Method : Get
     * API No : 16.5
     * url : /api/v1/{cmpnNo}/schedule/{schdNo}
     * **/
    getScheduleInfo(schdNo: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/schedule/${schdNo}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * schedule
     * schedule 프리뷰
     * Method : Get
     * API No : 16.6
     * url : /api/v1/{cmpnNo}/schedule/preview/{schdNo}
     * **/
    getSchedulePriview(schdNo: any, queryString?: any) {
        const queryParam = (queryString === undefined ? '' : queryString);
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/schedule/preview/${schdNo}${queryParam}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * schedule
     * schedule 수정
     * Method : Put
     * API No : 16.7
     * url : /api/v1/{cmpnNo}/schedule/{schdNo}
     * **/
    putSchedule(schdNo, putData) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/schedule/${schdNo}`;

        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }
    /**
     * schedule
     * schedule 삭제 validation
     * Method : Delete
     * API No : 16.10
     * url : /api/v1/{cmpnNo}/schedule/{schdNo}/validate/delete
     * **/
    validateDeleteSchedule(schdNo: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/schedule/${schdNo}/validate/delete`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * schedule
     * schedule 삭제
     * Method : Delete
     * API No : 16.8
     * url : /api/v1/{cmpnNo}/schedule/{schdNo}
     * **/
    async deleteSchedule(schdNo: any) {
        try {
            // 사용중인 스케줄은 삭제 할 수 없다.
            const validateResult = await this.validateDeleteSchedule(schdNo);

            if (validateResult.json().addInfo.status === -1) {
                return new Promise((resolve) => {
                    resolve(validateResult);
                });
            }

            const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/schedule/${schdNo}`;

            return this.http
                .delete(url)
                .toPromise()
                .then(res => res)
                .catch(this.handleError);
        } catch(e) {
            await this.handleError(e);
        }
    }

    /**
     * schedule
     * schedule Override 삭제
     * Method : Delete
     * API No : 16.9
     * url : /api/v1/{cmpnNo}/schedule/override/{schdOvrdLayerNo}
     * **/
    deleteScheduleOverride(schdNo: any, schdOvrdLayerNo: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/schedule/${schdNo}/override/${schdOvrdLayerNo}`;

        return this.http
            .delete(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    mappTrgtListToLocal(mappTrgtList: any[]) {
        const usedUserList = [];

        _.uniqBy(mappTrgtList, 'trgtNo').forEach(_data => {
            if (!_.find(usedUserList, {'trgtNo': _data['trgtNo']})) {
                let colorIndex = 0;
                for (let i = 0; i < 50; i++) {
                    colorIndex = i;
                    if (!_.find(usedUserList, {'colorIndex': i})) {
                        break;
                    }
                }
                usedUserList.push({
                    trgtNo : _data['trgtNo'],
                    trgtDispNm : _data['trgtDispNm'],
                    trgtTypeCd : 'MAPTR110',
                    trgtStatCd: _data['trgtStatCd'],
                    trgtRoleCd: _data['trgtRoleCd'],
                    type: _data['mappCnfgList'][0].substr(0, 1),
                    /*aplyEndDt: _data['aplyEndDt'],*/
                    colorIndex : colorIndex % 50
                });
            }
        });

        // 유효한 사용자 판단하기 위한 로직 추가
        /*usedUserList.forEach(user => {
            mappTrgtList.forEach(trgt => {
                if (user['trgtNo'] === trgt['trgtNo'] && trgt['aplyEndDt'] === '2999-12-31 23:59:59') {
                    user['aplyEndDt'] = '2999-12-31 23:59:59';
                }
            });
        });*/

        const mappTrgtInfo = [];
        mappTrgtList.forEach((mappTrgt: any[], index) => {
            mappTrgt['mappCnfgList'].forEach((cnfg) => {
                if (cnfg.substr(0, 1) === 'L') {
                    mappTrgtInfo.push({
                        type: 'layer',
                        layerNo: Number(cnfg.substr(1, 5)),
                        asgnOrdrIdx: Number(cnfg.substr(7)),
                        trgtDispNm: mappTrgt['trgtDispNm'],
                        trgtNo: mappTrgt['trgtNo'],
                        aplyEndDt: mappTrgt['aplyEndDt'],
                        aplyStDt: mappTrgt['aplyStDt'],
                        aplyTxnNo: mappTrgt['aplyTxnNo'],
                        trgtStatCd: mappTrgt['trgtStatCd'],
                        trgtTypeCd: mappTrgt['trgtTypeCd'],
                        colorIndex: _.find(usedUserList, {'trgtNo': mappTrgt['trgtNo']}).colorIndex,
                        trgtRoleCd: mappTrgt['trgtRoleCd'],
                        trgtRoleNo: mappTrgt['trgtRoleNo']
                    });
                } else {
                    mappTrgtInfo.push({
                        type: 'override',
                        layerNo: Number(cnfg.substr(1, 5)),
                        asgnOrdrIdx: null,
                        trgtDispNm: mappTrgt['trgtDispNm'],
                        trgtNo: mappTrgt['trgtNo'],
                        aplyEndDt: mappTrgt['aplyEndDt'],
                        aplyStDt: mappTrgt['aplyStDt'],
                        trgtStatCd: mappTrgt['trgtStatCd'],
                        trgtTypeCd: mappTrgt['trgtTypeCd'],
                        colorIndex: index % 50,
                        trgtRoleCd: mappTrgt['trgtRoleCd'],
                        trgtRoleNo: mappTrgt['trgtRoleNo']
                    });
                }
            });
        });

        StorageUtils.setItem('alertNow.mappTrgtInfo', JSON.stringify(mappTrgtInfo));
        return usedUserList;
    }


    postPreview(postData) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/schedule/preview/10080`;
        return this.http
            .post(url, JSON.stringify(postData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    private handleError(error: any) {
        //console.error('An error occurred', error);
        return Promise.resolve(error.message || error);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/src/api/schedule.services.ts